let initialState = null;

function blob(state = initialState, action) {
  if (action.type === "URL_TO_BLOB") {
    return action.res;
  } else return state;
}

export default blob;
